export default __webpack_public_path__ + "static/media/USA-flag.587b3c88fcd49dc7142d6eebffdd3ca2.svg";